/**
 * <size-chart-modal> — slide-over panel with the Twin Flame size chart.
 * Listens for clicks on [data-size-chart-open] (inside this element),
 * [data-size-chart-close], and [data-size-chart-overlay]. ESC also closes.
 */
class SizeChartModal extends globalThis.ThemeElement {
  connectedCallback() {
    this.panel = this.$('[data-size-chart-panel]');
    this.overlay = this.$('[data-size-chart-overlay]');
    this._releaseFocus = null;

    this.$$('[data-size-chart-open]').forEach((btn) => {
      this.on(btn, 'click', (e) => { e.preventDefault(); this.open(); });
    });
    this.$$('[data-size-chart-close]').forEach((btn) => {
      this.on(btn, 'click', (e) => { e.preventDefault(); this.close(); });
    });
    if (this.overlay) this.on(this.overlay, 'click', () => this.close());
    this.on(window, 'keydown', (e) => { if (e.key === 'Escape' && this.isOpen) this.close(); });
  }

  get isOpen() { return this.panel?.getAttribute('aria-hidden') === 'false'; }

  open() {
    if (!this.panel) return;
    this.panel.removeAttribute('hidden');
    this.panel.setAttribute('aria-hidden', 'false');
    this.panel.style.transform = 'translateX(0)';
    if (this.overlay) {
      this.overlay.classList.remove('hidden');
      this.overlay.setAttribute('aria-hidden', 'false');
    }
    document.body.classList.add('size-chart-open');
    globalThis.JunneTheme?.lockBodyScroll?.();
    this._releaseFocus = globalThis.JunneTheme?.trapFocus?.(this.panel);
  }

  close() {
    if (!this.panel) return;
    this.panel.setAttribute('aria-hidden', 'true');
    this.panel.style.transform = 'translateX(100%)';
    if (this.overlay) {
      this.overlay.classList.add('hidden');
      this.overlay.setAttribute('aria-hidden', 'true');
    }
    document.body.classList.remove('size-chart-open');
    globalThis.JunneTheme?.unlockBodyScroll?.();
    this._releaseFocus?.();
    this._releaseFocus = null;
    setTimeout(() => { if (!this.isOpen) this.panel.setAttribute('hidden', ''); }, 300);
  }
}

if (!customElements.get('size-chart-modal')) customElements.define('size-chart-modal', SizeChartModal);
